import { getIn18Text, api, locationHelper } from 'api';
import { useCallback, useEffect, useMemo } from 'react';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
import { INIT_TASK_KEY, INIT_TASK_TIME_KEY } from '@web-mail/common/constant';
import { useAppSelector, useAppDispatch, ContactActions } from '@web-common/state/createStore';
import { doGetContactListAsync, refreshContactData, refreshContactDataByEmails } from '@web-common/state/reducer/contactReducer';
import { actions as mailTabActions, tabType } from '@web-common/state/reducer/mailTabReducer';
import { eventApi } from '@web-unitable-crm/api';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import { getSendCount } from '@/components/Layout/Customer/components/hooks/useEdmSendCount';
const storageApi = api.getDataStoreApi();
const systemApi = api.getSystemApi();
const ReducerComponent = () => {
    const dispatch = useAppDispatch();
    const contactMap = useAppSelector(state => state.contactReducer.contactMap);
    const receivers = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.receiver; });
    const updateCallback = (e) => {
        const { contact_personal: personalIdMap, contact_enterprise: enterpriseIdMap, isAll = false, emails } = e.eventData;
        const { _account } = e;
        if (isAll) {
            dispatch(ContactActions.doCleanContactMap());
            return;
        }
        const contactIdList = Object.keys(contactMap);
        if (contactIdList.length && (personalIdMap || enterpriseIdMap)) {
            const idList = [
                ...((personalIdMap === null || personalIdMap === void 0 ? void 0 : personalIdMap.insertDiff) || []),
                ...((personalIdMap === null || personalIdMap === void 0 ? void 0 : personalIdMap.updateDiff) || []),
                ...((enterpriseIdMap === null || enterpriseIdMap === void 0 ? void 0 : enterpriseIdMap.insertDiff) || []),
                ...((enterpriseIdMap === null || enterpriseIdMap === void 0 ? void 0 : enterpriseIdMap.updateDiff) || []),
            ];
            const deleteIdList = [...((personalIdMap === null || personalIdMap === void 0 ? void 0 : personalIdMap.deleteDiff) || []), ...((enterpriseIdMap === null || enterpriseIdMap === void 0 ? void 0 : enterpriseIdMap.deleteDiff) || [])];
            const refreshIdList = contactIdList.filter(id => idList.includes(id));
            const deleteList = contactIdList.filter(id => deleteIdList.includes(id));
            if (deleteList.length) {
                dispatch(ContactActions.doDeleteContactMap({ idList: deleteList, _account }));
            }
            if (refreshIdList.length) {
                doGetContactListAsync(refreshIdList, _account);
            }
        }
        if (emails && (emails === null || emails === void 0 ? void 0 : emails.length) && _account) {
            const emailMap = new Map(emails.map(email => [email, email]));
            refreshContactDataByEmails({ [_account]: emails }, emailMap);
        }
    };
    const jumpYingxiaoCallback = useCreateCallbackForEvent(() => {
        const emailSet = new Set();
        const emailList = [];
        if (!receivers)
            return;
        receivers.forEach(item => {
            const email = item.contactItem.contactItemVal;
            const name = item.contact.contact.contactName;
            if (!emailSet.has(email)) {
                emailList.push({
                    contactName: name,
                    contactEmail: email,
                    sourceName: '发信失败',
                    increaseSourceName: 'sendMailFail',
                });
                emailSet.add(email);
            }
        });
        getSendCount({
            emailList,
            from: 'sendMailFail',
            back: locationHelper.getHash(),
        });
    });
    const PersonalMarkCallback = (e) => {
        const { actionType, data, noNewMarkData } = e.eventData;
        if (noNewMarkData) {
            return;
        }
        const emailMap = new Map();
        const orgIdMap = new Map();
        const type = actionType === 'update' ? 'add' : 'cancel';
        data === null || data === void 0 ? void 0 : data.forEach(item => {
            var _a;
            if (item.type === 2) {
                orgIdMap.set(item.value, actionType === 'update');
            }
            else if (item.type === 1) {
                (_a = item.emails) === null || _a === void 0 ? void 0 : _a.forEach(email => {
                    const contactIdSet = emailMap.get(email) || new Set();
                    contactIdSet.add(item.value);
                    emailMap.set(email, contactIdSet);
                });
            }
        });
        if (orgIdMap.size) {
            dispatch(ContactActions.doUpdateOrgMarkedMap(orgIdMap));
        }
        if (emailMap.size) {
            dispatch(ContactActions.doUpdateEmailMarkedMap({ type, isAll: false, data: emailMap }));
        }
    };
    const customerMapChangedCallback = async (e) => {
        const { target } = e.eventData;
        if (process.env.BUILD_ISELECTRON && !systemApi.isMainWindow() && target === 'all') {
            const cleanRes = await refreshContactData();
            console.log('[ReducerComponent] refreshContactData res', cleanRes);
        }
    };
    const initTaskNameMap = useMemo(() => {
        const map = {
            readMailTab: task => {
                setTimeout(() => {
                    const mailTabModel = {
                        id: task === null || task === void 0 ? void 0 : task.id,
                        title: getIn18Text('DUXIN'),
                        type: tabType.read,
                        closeable: true,
                        isActive: true,
                        extra: {
                            accountId: '',
                        },
                    };
                    dispatch(mailTabActions.doSetTab(mailTabModel));
                }, 1000);
            },
            atCtTab: () => {
                storageApi.putSync('atCtTab', new Date().getTime() + '');
            },
            atSdTab: () => {
                storageApi.putSync('atSdTab', new Date().getTime() + '');
                storageApi.putSync('atSdMsilList', new Date().getTime() + '');
            },
        };
        return map;
    }, []);
    const filterTask = useCallback(list => list.filter(item => initTaskNameMap[item === null || item === void 0 ? void 0 : item.type]), []);
    const clearInitStorage = () => {
        storageApi.del(INIT_TASK_TIME_KEY, { noneUserRelated: true });
        storageApi.del(INIT_TASK_KEY, { noneUserRelated: true });
    };
    useMemo(() => {
        try {
            let task = '';
            let taskTime = '';
            const taskStorage = storageApi.getSync(INIT_TASK_KEY, { noneUserRelated: true });
            const taskTimeStorage = storageApi.getSync(INIT_TASK_TIME_KEY, { noneUserRelated: true });
            if (taskStorage === null || taskStorage === void 0 ? void 0 : taskStorage.suc) {
                task = taskStorage.data || '';
            }
            if (taskTimeStorage === null || taskTimeStorage === void 0 ? void 0 : taskTimeStorage.suc) {
                taskTime = taskTimeStorage.data || '';
            }
            if (taskTime) {
                if (new Date().getTime() - new Date(+taskTime).getTime() > 60000) {
                    clearInitStorage();
                    return;
                }
            }
            if (task) {
                const taskList = JSON.parse(task);
                if (taskList && taskList.length) {
                    const resTaskList = filterTask(taskList);
                    resTaskList.forEach(item => {
                        if (initTaskNameMap[item.type] && typeof initTaskNameMap[item.type] === 'function') {
                            initTaskNameMap[item.type](item);
                        }
                    });
                }
                clearInitStorage();
            }
        }
        catch (e) {
            console.warn('[initTask Error]', e);
            clearInitStorage();
        }
    }, []);
    const selectOrgCallback = (e) => {
        const list = e.eventData;
        dispatch(ContactActions.doUpdateOrgMap(list));
    };
    useMsgRenderCallback('contactAccountNotify', e => {
        updateCallback(e);
    });
    useMsgRenderCallback('selectOrgNotify', e => {
        selectOrgCallback(e);
    });
    useMsgRenderCallback('contactPersonalMarkNotify', e => {
        PersonalMarkCallback(e);
    });
    useMsgRenderCallback('customerMapChangeNotify', e => {
        customerMapChangedCallback(e);
    });
    useEffect(() => {
        if (process.env.BUILD_ISEDM) {
            if ((process.env.BUILD_ISELECTRON && systemApi.isMainWindow()) || (!process.env.BUILD_ISELECTRON && systemApi.isMainPage())) {
                const id = eventApi.registerSysEventObserver('sendMailFailJumpYingxiao', {
                    func: jumpYingxiaoCallback,
                });
                return () => {
                    eventApi.unregisterSysEventObserver('sendMailFailJumpYingxiao', id);
                };
            }
        }
        return () => { };
    }, []);
    return null;
};
export default ReducerComponent;
